import { FunctionComponent, useEffect, useRef } from 'react'
import styled, { css } from 'styled-components'

import AppNexus from '@components/AppNexus'
import usePageMetadata from '@hooks/usePageMetadata'
import { mobileCSS, tabletCSS } from '@measures/responsive'
import { useQueryClient } from 'react-query'
import useBrandingDay from '@hooks/useBrandingDay'

const SidebarWrapper = styled.div`
  height: calc(100vh - 110px);
  position: relative;

  position: sticky;
  top: 110px;
  box-sizing: border-box;

  ${tabletCSS(css`
    display: none;
  `)}

  ${mobileCSS(css`
    display: none;
  `)}
`

const AdWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

interface StyledAnchorProps {
  isBrandingDayVisible: boolean
}

const StyledAnchor = styled.a<StyledAnchorProps>`
  ${({ isBrandingDayVisible }) =>
    !isBrandingDayVisible
      ? css`
          display: none;
        `
      : css`
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: block;
        `}
`

const SidebarAd: FunctionComponent = () => {
  const { sideBarAd, url } = usePageMetadata()
  const sidebarAdRef = useRef<HTMLDivElement>(null)
  const queryClient = useQueryClient()
  const { isVisible, options } = useBrandingDay()

  useEffect(() => {
    queryClient.setQueryData('sidebar-ad-ref', sidebarAdRef)
    return () => {
      queryClient.removeQueries('sidebar-ad-ref', { exact: true })
    }
  }, [queryClient, sidebarAdRef])

  if (!(sideBarAd?.isAdDisabled === false)) {
    return null
  }

  return (
    <SidebarWrapper>
      <AdWrapper ref={sidebarAdRef}>
        {options?.clickUrl && (
          <StyledAnchor
            target="_blank"
            rel="noopener nofollow"
            href={options?.clickUrl}
            isBrandingDayVisible={isVisible}
          />
        )}
        <AppNexus {...sideBarAd} key={url} />
      </AdWrapper>
    </SidebarWrapper>
  )
}

export default SidebarAd
